<template>
  <div class="product-video">
    <Heading
      font-size="48px"
      line-height="72px"
      letter-spacing="-0.015em"
      font-color="#000000"
      class="product-video__title"
    >
      Confira o vídeo com mais detalhes da peça
    </Heading>
    <div
      class="product-video__player"
      :class="{ active: videoplaying }"
    >
      <video
        ref="myvideo"
        autoplay
        width="100%"
        controls
      >
        <source type="video/mp4" />
        Your browser does not support HTML video.
      </video>
      <button
        class="product-video__close"
        @click="closeVideo"
      >
        <v-img :src="require('../../../assets/close-icon.svg')">
        </v-img>
      </button>
    </div>
    <div class="overlay"></div>
    <div class="product-video__thumb">
      <v-img
        :src="require('../../../assets/thumb-video.png')"
      >
      </v-img>
      <v-img
        class="product-video__play"
        :src="require('../../../assets/play-icon.svg')"
        @click="playVideo"
      >
      </v-img>
    </div>
  </div>
</template>

<script>
import Heading from '@/components/Heading/Heading.vue';

export default {
  name: 'ProductVideo',
  components: {
    Heading,
  },
  data() {
    return {
      videoplaying: false,
    };
  },
  methods: {
    playVideo() {
      const videoFile = require('../../../assets/placeholder-video.mp4');
      this.$refs.myvideo.src = videoFile;
      this.videoplaying = !this.videoplaying;
    },
    closeVideo() {
      this.$refs.myvideo.src = '';
      this.videoplaying = !this.videoplaying;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/static/css/Variables.scss';
.product-video {
  padding: 0 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: $lg) {
    min-width: 90vw;
    align-items: flex-start;
  }
  @media (max-width: $md) {
    padding: 0 20px;
  }
  &__title {
    @media (max-width: $xl) {
      line-height: 30px !important;
      font-size: 24px !important;
      text-align: left;
      margin-bottom: 20px;
    }
  }
  @media (max-width: $xl) {
    flex-direction: column;
  }

  &__close {
    width: 50px;
    height: 50px;
    position: fixed;
    top: 600px;
    right: 100px;
    border: none;
  }

  &__thumb {
    width: 100%;
    position: relative;
  }

  &__play {
    height: 132px;
    width: 132px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
  }

  &__player {
    position: fixed;
    width: 100vw;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    transition: 0.5s;
    visibility: hidden;
    z-index: 1000;

    &.active {
      padding: 600px;
      transform: translate(-50%, -50%) scale(1);
      visibility: visible;

      + .overlay {
        opacity: 1;
        transition: opacity 0.5s;
        visibility: visible;
      }
    }

    > video {
      z-index: 600;
      position: relative;
    }

    + .overlay {
      display: block;
      width: 100%;
      height: 100%;
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      background-color: rgba($color: #000000, $alpha: 0.5);
      z-index: 500;
      opacity: 0;
      visibility: hidden;
      transition: 0.5s;
    }
  }
}
</style>
